//redux
import { useSelector } from "react-redux"

// *************************************************************
//     Misc
export function useCredencialesCredenciales() {
  return useSelector(state => state.Credenciales.context.credenciales)
}

export function useCredencialesError() {
  return useSelector(state => state.Credenciales.context.error)
}

export function useCredencialesIsLoading() {
  return useSelector(state => state.Credenciales.context.loading)
}
